import stage from './js/Stage';
import gameManager from './js/GameManager';

let x = 0;
const FPS = 60;
createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
createjs.Ticker.framerate = FPS;
let printPausedOnce = false;
createjs.Ticker.addEventListener('tick', ev => {
  gameManager.run();
  x += 1;
  if (ev.paused && !printPausedOnce) {
    printPausedOnce = true;
    console.log('Paused');
    return;
  } else if (ev.paused) {
    return;
  }
  stage.update(ev);
  printPausedOnce = false;
  if (x % 100 === 0) {
    console.log(`FPS:${createjs.Ticker.getMeasuredFPS()}`);
  }
  gameManager.rendered();
});
